import { Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { ObservableInput } from 'ngx-observable-input';
import { BehaviorSubject, Observable, of } from 'rxjs';


import { Multi } from '../../../../interfaces/multi.interface';


import { GraphQlAppendWheres } from '../../../../operators/graphql/append-wheres/graphql-append-wheres.operator';
import { GraphQlQueryExecutor } from '../../../../operators/graphql/query-executor/graphql-query-executor.operator';
import { NgxMultiNameTemplate } from '../../../../operators/ngx/multi-name-template/multi-name-template.operator';
import { map, first } from 'rxjs/operators';


import { EveInternal } from '../../../../operators/eve/interval/eve-interval.operator';
import { NgxMultiSingleNameFunc } from '../../../../operators/ngx/multi-single-name-func/multi-single-name-func.operator';


import { StackedBarChartOptions } from '../../../../components/GraphQL/StackedBarChartPagination/stackedbarchartpagination.component';
import { MatDialog } from '@angular/material/dialog';
import { FunctionNumberPopUpComponent } from '../../../../components/function-number-pop-up/function-number-pop-up.component';
import { GraphQLComparision } from '../../../../enums/GraphQLComparision.enum';
import { GraphQLConnector, GraphQLFilter, GraphQlQuery, IGraphQlService } from '../../../../services/GraphQl/IGraphQL.service';
import { GraphQlQueryResultToNgxMulti } from '../../../../operators/graphql/query-result-to-ngx-multi/graphql-query-result-to-ngx-multi.operator';
import { IVisibilityStateService } from '../../../../services/VisibilityState/IVisibilityState.service';




@Component({
  selector: 'missed-calls-by-group',
  templateUrl: './missed-calls-by-group.component.html',
  styleUrls: ['./missed-calls-by-group.component.css']
})
export class MissedCallsByGroupComponent implements OnInit {
  @ViewChild('template') template: TemplateRef<any>;

  @ObservableInput()
  @Input("loading")
  loading$: TemplateRef<any>;

  @ObservableInput()
  @Input("noResults")
  noResults$: TemplateRef<any>;


  @ObservableInput()
  @Input("wheres")
  wheres$: Observable<GraphQLFilter[]>;


  @ObservableInput()
  @Input("company")
  company$: Observable<any>;

  @Output()
  select: EventEmitter<any> = new EventEmitter();


  missedCallsByGroupOptions: StackedBarChartOptions = {
    width: 1000,
    height: 400,
    chartHeader: "Missed Calls By Groups",
    xAxisLabel: "Groups",
    yAxisLabel: "Quantity",
    colourScheme: null
  };

  missedCallsByGroup_MissedAndDiverted: Observable<Multi[]>;
  missedCallsByGroup_Voicemail: Observable<Multi[]>;
  missedCallsByGroup: Observable<Multi[]>;


  selectedGroups: BehaviorSubject<any[]> = new BehaviorSubject<any[]>(null);
  extraWheres: Observable<GraphQLFilter[]> = this.selectedGroups.pipe(
    map(eveUsers => {

      if (eveUsers == null || eveUsers.length == 0) return <GraphQLFilter[]>[];

      return <GraphQLFilter[]>[
        //{ path: "ownerTypeId", comparison: GraphQLComparision.EQUAL, value: "0" },
        {
          path: null, comparison: GraphQLComparision.EQUAL, value:null,
          groupedExpressions: eveUsers.map(group => ({
            path: null, comparison: GraphQLComparision.EQUAL, value: null,
            groupedExpressions: [
              {
                path: "targetOwnerTypeId",
                comparison: GraphQLComparision.EQUAL,
                value: group.ownerTypeId,
              },
              {
                path: "targetOwnerId",
                comparison: GraphQLComparision.IN,
                value: group.ownerId,
              }
            ],
            connector: GraphQLConnector.OR
          }))
        }
      ];
    })
  );



  constructor(
    public graphQlService: IGraphQlService,
    public dialog: MatDialog,
    public visibilityStateService: IVisibilityStateService
  ) {
  }

  ngOnInit(): void {


    



    this.missedCallsByGroup = of<GraphQlQuery>({
      dataset: "telepoCdrsPage",
      selects: [
        {
          field: "count"
        },
        {
          field: "telepoCdrAnsweredType",
        },
        {
          field: "targetOwnerTypeId",
        },
        {
          field: "targetOwnerId",
        },
        {
          field: "targetOwner",
        },
      ],
      wheres: [
        { path: "targetOwnerTypeId", comparison: GraphQLComparision.IN, value: [2, 3] },
        { path: "type", comparison: GraphQLComparision.EQUAL, value: 2 },
        { path: "telepoCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: null },
        { path: "telepoCdrAnsweredType", comparison: GraphQLComparision.NOT_EQUAL, value: "EVE_USER" },
      ],
      groupBys: [
        { path: "telepoCdrAnsweredType" },
        { path: "targetOwnerTypeId" },
        { path: "targetOwnerId" }
      ],
      page: 0,
      pageSize: -1
    }).pipe(
      GraphQlAppendWheres(this.wheres$, this.extraWheres),
      GraphQlQueryExecutor(of(this.graphQlService)),
      EveInternal(5000, this.visibilityStateService.VisibilityState()),
      GraphQlQueryResultToNgxMulti(),
      NgxMultiSingleNameFunc(multi => {

        if (multi.name == "Diverted".toUpperCase()) {
          return "Diverted";
        }
        else if (multi.name == "Voicemail".toUpperCase()) {
          return "Voicemail";
        }
        else if (multi.name == "missed".toUpperCase()) {
          return "Missed";
        }
        else if (multi.name == "Disconnected".toUpperCase()) {
          return "Caller Disconnected";
        }
        else if (multi.name == "Close".toUpperCase()) {
          return "Queue Closed";
        }
        else if (multi.name == "Eve_User".toUpperCase()) {
          return "EveUser";
        }
        else if (multi.name == "Routing_Rule".toUpperCase()) {
          return "Routing Rule";
        }
        else if (multi.name == "Queue_Timeout".toUpperCase()) {
          return "Queue Time Out";
        }
        else if (multi.name == "Night_Mode".toUpperCase()) {
          return "Queue Forward";
        }
        else if (multi.name == "Over_Flow".toUpperCase()) {
          return "Max Calls Exceeded";
        }
        else if (multi.name == "Acd_Fallback".toUpperCase()) {
          return "No Agents";
        }

        return multi.name;
      }),
      NgxMultiNameTemplate("${this.targetOwner}")
    );


   

  }

  public async openGroupSelectionDialog() {


    const company = await this.company$.pipe(first()).toPromise();

    this.dialog.open(FunctionNumberPopUpComponent, {
      data: {
        wheres: [{
          path: "organisationNode",
          comparison: GraphQLComparision.IS_DESCENDANT_OF,
          value: company?.organisationNode ?? null
        }],
        selectedFunctionNumbers: this.selectedGroups.value
      }
    }).afterClosed().subscribe(functionNumbers => { if (functionNumbers != null) this.selectedGroups.next(functionNumbers); });

  }

  public onSelect(data) {
    this.select.emit(data);
  }
}
